import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga' ;

import './index.css';
import App from './App';

export const GApageView = (page) => {    
  ReactGA.pageview(page);   
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);